import { component } from 'picoapp'

export default component((node, ctx) => {
  const accordionHeader = node.querySelector(".accordion-header")
  if(accordionHeader) {
    accordionHeader.addEventListener('click', (e) => {
      node.classList.toggle("active")
    })
  }
});